import { createSlice } from '@reduxjs/toolkit';
import { ConversationStarter, Nullable } from '../../types';
import { Paginated } from '../../services/api-handlers/pagination';
import { takeOne } from '../../helpers/store';
import {
    createConversationStarter,
    deleteConversationStarter,
    getAllConversationStarters,
    getConversationStarter,
    listConversationStarters,
    updateConversationStarter,
} from '../thunks/conversation-starter-thunks';
import { ReducerState } from '../configure-store';

export interface ConversationStarterState extends ReducerState {
    data: Paginated<ConversationStarter>;
    current: Nullable<ConversationStarter>;
}

const initialState: ConversationStarterState = {
    error: '',
    loading: 'none',
    requestIds: [],
    current: null,
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
};

const slice = createSlice({
    name: 'conversation-starter',
    initialState,
    reducers: {
        resetConversationStarterCurrent: (state: ConversationStarterState) => {
            state.current = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(listConversationStarters.pending, takeOne.pendingActionCase)
            .addCase(listConversationStarters.fulfilled, (state, action) => {
                takeOne.fulfilledActionCase(state, action);
                state.data = action.payload;
            })
            .addCase(listConversationStarters.rejected, takeOne.rejectedActionCase)

            .addCase(getAllConversationStarters.pending, takeOne.pendingActionCase)
            .addCase(getAllConversationStarters.fulfilled, takeOne.fulfilledActionCase)
            .addCase(getAllConversationStarters.rejected, takeOne.rejectedActionCase)

            .addCase(getConversationStarter.pending, takeOne.pendingActionCase)
            .addCase(getConversationStarter.fulfilled, (state, action) => {
                takeOne.fulfilledActionCase(state, action);
                state.current = action.payload;
            })
            .addCase(getConversationStarter.rejected, takeOne.rejectedActionCase)

            .addCase(createConversationStarter.pending, takeOne.pendingActionCase)
            .addCase(createConversationStarter.fulfilled, takeOne.fulfilledActionCase)
            .addCase(createConversationStarter.rejected, takeOne.rejectedActionCase)

            .addCase(updateConversationStarter.pending, takeOne.pendingActionCase)
            .addCase(updateConversationStarter.fulfilled, takeOne.fulfilledActionCase)
            .addCase(updateConversationStarter.rejected, takeOne.rejectedActionCase)

            .addCase(deleteConversationStarter.pending, takeOne.pendingActionCase)
            .addCase(deleteConversationStarter.fulfilled, takeOne.fulfilledActionCase)
            .addCase(deleteConversationStarter.rejected, takeOne.rejectedActionCase);
    },
});

export const { resetConversationStarterCurrent } = slice.actions;

export default slice.reducer;
